export const RESPONSE_PAGE = 'responses';
export const IMPORT_HH_VACANCIES = 'importHhVacancies';
